<template>
  <v-container>
    <v-layout row wrap>
      <b-container class="bv-example-row" fluid="md">
        <b-row>
          <v-combobox
            :items="legends"
            label="Usuario"
            placeholder="Selecciona un usuario"
            item-text="name"
            @change="updateData($event)"
          ></v-combobox>
        </b-row>
      </b-container>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-layout wrap>
          <v-flex xs12 justify-center>
            <h2>{{currentYear}}</h2>
          </v-flex>
          <v-flex xs12>
            <graph-bar :key="componentKey" v-if="loaded" :datasets="normalizedDataSets" :labels="labels" v-on:on-receive="handleClick"></graph-bar>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6>
        <v-layout wrap v-if="showDetail">
          <v-flex xs12>
            <h2>{{labels[selectedMonth]}}</h2>
          </v-flex>
          <v-flex xs12>
            <graph-reactive-bar  :chart-data="monthDetails"></graph-reactive-bar>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import {getUserQueries} from '../services/user';

export default {

  data() {
    return {
      loaded: false,
      showDetail: false,
      originalData: [],
      colors: ['#FC2525', '#05CBE1', '#9C27B0', '#009688', '#CDDC39', '#9E9E9E', '#795548', '#4CAF50' ],
      labels: ['Enero', 'Febrero', 'Marzo', 'Abril',
        'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
        'Octubre', 'Noviembre', 'Diciembre'],
      normalizedDataSets: [],

      monthDetails: {
        labels: [],
        datasets: [],
      },
      legends: [],
      selectedMonth: 0,
      componentKey: 0,
      itemSelected: {name: ''}
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    updateData(legendSelected){
      this.itemSelected = legendSelected
      this.legends.forEach(it => {
        it.show = legendSelected.name === it.name ? 'true' : 'false'
      })
      console.log(this.legends);
      this.normalizedDataSets = this.calculatedDataSets();
      this.componentKey += 1
      this.showDetail = false
    },
    handleClick(event) {
      var index = event.index
      if (index !== undefined && index !== null && index >= 0) {
        this.selectedMonth = index;
        this.axios.get(`/users/dailyQueries?month=${index + 1}`)
        .then((result) => {
          this.showDetail = false;
          const daysInMonth = this.getDaysInMonthForResult(result.data);

          // https://stackoverflow.com/questions/3746725/how-to-create-an-array-containing-1-n
          this.monthDetails = {
            labels: [...Array(daysInMonth).keys()].map((x) => x + 1),
            datasets: this.calculatedDailyDataSets(result.data, daysInMonth),
          };
          this.showDetail = true;
        })
        .catch((error) => {
          this.$emit('error', error);
        });
      }
    },
    chargeLegends() {
      for (const originalElement of this.originalData) {
        if (this.legends.findIndex(it => it.name === originalElement.name) === -1){
          this.legends.push({name: originalElement.name, show: false, color: this.getRandomColor()})
        }
      }
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF'.split('');
      var color = '#';
      for (var i = 0; i < 6; i++ ) {
          color += letters[Math.round(Math.random() * 15)];
      }
      if (this.legends.findIndex(it => it.color === color) === -1){
        return color
      }
      return this.getRandomColor()
    },
    getVisibility(legend) {
      const item = this.legends.find(it => it.name === legend)
      if (!!item){
        return !(item.show === 'true')
      }
      return false
    },
    getColorBar(legend){
      const item = this.legends.find(it => it.name === legend)
      return item.color
    },
    calculatedDataSets() {
      // Make the required datasets from the info bring from the backend
      const newDataSet = [];
      let dataSetIndex = 0;
      for (const originalElement of this.originalData) {
        let dataSetElement = newDataSet.filter((e) => {
          return e.label === originalElement.name;
        });
        if (!dataSetElement.length) {
          dataSetElement = {
            label: originalElement.name,
            backgroundColor: this.getColorBar(originalElement.name),
            data: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            user_id: originalElement.user_id,
            hidden: this.getVisibility(originalElement.name),
          };
          dataSetIndex++;
          newDataSet.push(dataSetElement);
        } else {
          dataSetElement = dataSetElement[0];
        }
        dataSetElement.data[originalElement.month - 1] =  originalElement.queries;
      }
      return newDataSet;
    },

    calculatedDailyDataSets(originalData, daysInMonth) {
      // Make the required datasets from the info bring from the backend
      const newDataSet = [];
      let dataSetIndex = 0;
      for (const originalElement of originalData) {
        let dataSetElement = newDataSet.filter((e) => {
          return e.label === originalElement.name;
        });
        if (!dataSetElement.length) {
          dataSetElement = {
            label: originalElement.name,
            backgroundColor: this.getColorBar(this.itemSelected.name),
            data: Array.from({length: daysInMonth}, () => 0),
            user_id: originalElement.user_id,
            hidden: originalElement.name === this.itemSelected.name ? false : true
          };
          dataSetIndex++;
          newDataSet.push(dataSetElement);
        } else {
          dataSetElement = dataSetElement[0];
        }
        dataSetElement.data[originalElement.day - 1] =  originalElement.queries;
      }
      return newDataSet;
    },
    getDaysInMonthForResult(originalData) {
      const firstElement = originalData[0];
      return this.getDaysInMonth(firstElement.year, firstElement.month);
    },

    getDaysInMonth(year, month) {
      // Here January is 1 based
      // Day 0 is the last day in the previous month
      return new Date(year, month, 0).getDate();
      // Here January is 0 based
      // return new Date(year, month+1, 0).getDate();
    },


  },
  async mounted() {
    this.loaded = false;
    this.originalData = await getUserQueries();
    this.originalData = this.originalData.data;
        // this.originalData = [{"user_id":1,"name":"Administrador2", "year":2019,"month":3,"queries":"600"},{"user_id":1,"name":"Administrador","year":2019,"month":4,"queries":"575"},{"user_id":1,"name":"Administrador","year":2019,"month":5,"queries":"265"},{"user_id":1,"name":"Administrador","year":2019,"month":6,"queries":"869"},{"user_id":1,"name":"Administrador","year":2019,"month":7,"queries":"358"},{"user_id":1,"name":"Administrador","year":2019,"month":8,"queries":"14"},{"user_id":1,"name":"Administrador","year":2019,"month":9,"queries":"15"},{"user_id":1,"name":"Administrador","year":2019,"month":10,"queries":"32"},{"user_id":1,"name":"Administrador","year":2019,"month":11,"queries":"115"},{"user_id":1,"name":"Administrador","year":2019,"month":12,"queries":"7"},{"user_id":1,"name":"Administrador","year":2020,"month":1,"queries":"18"}]
    this.chargeLegends()
    this.normalizedDataSets = this.calculatedDataSets();
    this.loaded = true;
  },
};
</script>
<style>
  .small {
    max-height: 400px;
  }

  .my-column{
    display: flex; 
    padding: 5px;
    /* margin: 5px */
  }

  .color-div {
    width: 50px;
    height: 100%;
  }
</style>
